export default __webpack_public_path__ + "static/media/passat-box.c78021e1.png";